module.exports = __webpack_public_path__ + "img/Weapon_178.416ac9ca.png";